<template>
  <div class="container body-container">
    <page-heading>
      <div slot="title">Your companies</div>
    </page-heading>
    <companies-table />
  </div>
</template>

<script>
import PageHeading from '@/components/app/PageHeading';
import CompaniesTable from '@/components/companies/companiesindex/Table';

export default {
  components: {
    CompaniesTable,
    PageHeading,
  },
};
</script>
